import React, { Component } from "react";
import arrPrev from '../../images/line-md_arrow-left.png';
import nextArrow from '../../images/line-md_arrow-right.png';
import * as Constanti from '../../Utils/constants.js';
import '../../style/categoriauno.css';
import '../../style/generic.css';
import Slider from "react-slick";
import axios from "axios";
import { Link } from "react-router-dom";
import CardTwo from "../cards/cardTwo.js";
import { motion } from "framer-motion";


class Category2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            video: [],
            // 1. Aggiungi lo stato per la slide attiva
            activeSlide: 0, 
            load: true, // Aggiunto load per coerenza con componentDidMount
        };
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        // 2. Lega la nuova funzione
        this.handleAfterChange = this.handleAfterChange.bind(this); 
    }

    next() {
        this.slider.slickNext();
    }
    previous() {
        this.slider.slickPrev();
    }

    // 3. Funzione per aggiornare lo stato dopo il cambio slide
    handleAfterChange(current) {
        this.setState({ activeSlide: current });
    }

    componentDidMount() {
        var apiBaseUrl = Constanti.url_Backend + "getVideoByCategory";
        var payload = {
            "id_categoria": this.props.category,
            "limit": this.props.limit
        }

        var self = this;
        axios.post(apiBaseUrl, payload).then(function (response) {
            if (response.data.data != null) {
                var location = response.data.data;
                self.setState({ video: location })
            } else {
                console.log("non ci sono video per questo id");
            }
            self.setState({ load: false });
        })
        .catch(function (error) {
            console.log(error);
            self.setState({ load: false });
        });
    }

    render() {
        // 4. Aggiungi afterChange alle settings
        var settings = {
            dots: false,
            infinite: false,
            speed: 500,
            centerMode: false,
            centerPadding: '60px',
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
            // Collega la funzione
            afterChange: this.handleAfterChange, 
        };
        const { video, activeSlide } = this.state;
        
        // 5. Determina la classe CSS per nascondere il pulsante "previous"
        const prevButtonClass = `buttonSlider left ${activeSlide === 0 ? 'hidden-button' : ''}`;
        
        // Determina la classe per nascondere il pulsante "next" quando è l'ultima slide
        // Questo è un bonus, la logica completa dipende da 'slidesToShow' e 'variableWidth'
        // Per uno slider `variableWidth`, la logica è più complessa, ma si può fare un check base
        // const isLastSlide = activeSlide >= video.length - 1; 
        // const nextButtonClass = `buttonSlider right ${isLastSlide ? 'hidden-button' : ''}`;


        return (
            <section className="categorysection">
                <div className="container">
                    <div className="slider-wrapper">
                        <div className="slider-title-wrapper">
                            <h2 className="h2">{this.props.name}</h2>
                            <Link to={'/categoria/' + this.props.category}>
                                <span className="button secondary small w-button heigth-32">Vedi tutti</span>
                            </Link>
                        </div>
                        <div className="slider-hover-wrapper">
                            <div className="divButton ">
                                {/* 6. Usa la classe dinamica */}
                                <button className={prevButtonClass} onClick={this.previous} disabled={activeSlide === 0}>
                                    <img className="prev-slick-arrow" height={51} width={51} src={arrPrev} alt="Previous" />
                                </button>
                                <button className="buttonSlider right" onClick={this.next}>
                                    <img className="next-slick-arrow" src={nextArrow} height={51} width={51} alt="Next" />
                                </button>
                            </div>
                            <div className="container-home slider-container" >
                                <Slider ref={c => (this.slider = c)} {...settings}>
                                    {video != null && video?.map((el, index) => (
                                        <motion.div
                                            key={el.id}
                                            initial={{ opacity: 0, y: 60 }}
                                            whileInView={{ opacity: 1, y: 0 }}
                                            viewport={{ once: true, amount: 0.2 }}
                                            transition={{
                                                duration: 0.9,
                                                delay: index * 0.2,
                                                ease: "easeOut"
                                            }}
                                            style={{ display: "flex" }}
                                        >
                                            <Link to={'/video/' + el.id}>
                                                <CardTwo
                                                    thumbnail={el.thumbnail}
                                                    title={el.title}
                                                    data={el.created_at}
                                                />
                                            </Link>
                                        </motion.div>
                                    ))}
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
export default Category2;